module.exports = __webpack_public_path__ + "assets/icons/calender.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/calender.png
// module id = ./src/styles/icons/sidemenu/calender.png
// module chunks = 0